import React from 'react';
import { styled as muiStyled } from '@mui/material/styles';
import Container, { ContainerProps } from '@mui/material/Container';

const AppContainer = ({ maxWidth = 'lg', ...props }: ContainerProps) => (
  <StyledContainer {...props} maxWidth={maxWidth} />
);

export default AppContainer;

const StyledContainer = muiStyled(Container)(
  ({ theme }) => `
  &.MuiContainer-root {
    width: 100%;
    margin: auto;
    padding-top: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(8)};
    padding-right: ${theme.spacing(4)};
    padding-left: ${theme.spacing(4)};
    ${theme.breakpoints.up('sm')} {
      padding-top: ${theme.spacing(12.5)};
      padding-bottom: ${theme.spacing(12.5)};
      padding-right: ${theme.spacing(12.5)};
      padding-left: ${theme.spacing(12.5)};
    }
  }
`,
);
